export default ({ videoCompose, videoVersion }) => ({
  courseId: videoVersion.data.video_id,
  courseTitle: videoCompose.data.name,
  isModalVariant: false,
});
